import RestClient from './RestClient'
import { fetchAppStateSuccess } from '../actions'

const ENTRY_POINT = 'home'
export default class HomeService {
  restClient: RestClient

  constructor(restClient: RestClient) {
    this.restClient = restClient
  }

  getAppState(): Promise<any> {
    return this.restClient.get(ENTRY_POINT)
      .then(homeInfo => this.restClient.dispatch(fetchAppStateSuccess(homeInfo)))
  }

  getAboutInfo(): Promise<IAboutPaneInfo[]> {
    return this.restClient.get(ENTRY_POINT + '/about-guide')
  }

  getMarqueeText(): Promise<string> {
    return this.restClient.get(ENTRY_POINT + '/marquee')
  }

  getTopRankWeek(): Promise<IUserRankDep[]> {
    return this.restClient.get(ENTRY_POINT + '/top-rank-week')
  }

  getTopRankMonth(): Promise<IUserRankDep[]> {
    return this.restClient.get(ENTRY_POINT + '/top-rank-month')
  }

  getTopRank(): Promise<IUserRankDep[]> {
    return this.restClient.get(ENTRY_POINT + '/top-rank')
  }

  getNLPaymentMethod(): Promise<INLPaymentMethod[]> {
    return this.restClient.get(ENTRY_POINT + '/get-nganluong-method')
  }

  getNLBankCode(paymentMethod: string): Promise<INLBankCode[]> {
    return this.restClient.get(ENTRY_POINT + '/get-nganluong-bank', {method: paymentMethod})
  }
  getRateCardKey(): Promise<number> {
    return this.restClient.get(ENTRY_POINT + '/get-rate-card-key')
  }

  getUserTopInfo(id: string): Promise<IUserTopInfo> {
    return this.restClient.get(ENTRY_POINT + '/get-user-top-info', {id})
  }

  getBankInfoList(): Promise<IBankInfo[]> {
    return this.restClient.get(ENTRY_POINT + '/get-bank-info')
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/services/HomeService.ts